type YoutubeType = {
    type: "youtube";
    id: string;
};

function isValidYoutubeId(id: string) {
    return /^[^#\\@&\\?]{5,12}$/.test(id);
}

function getYoutubeId(urlString: string): string | undefined {
    urlString = urlString.trim();
    if (
        urlString.startsWith("www.") ||
        urlString.startsWith("youtube.com") ||
        urlString.startsWith("m.youtube.com") ||
        urlString.startsWith("youtu.be") ||
        urlString.startsWith("youtube-nocookie.com")
    ) {
        urlString = "https://" + urlString;
    }

    let url: URL;
    try {
        url = new URL(urlString);
    } catch (e) {
        if (isValidYoutubeId(urlString)) {
            return urlString;
        }
        return undefined;
    }

    if (
        url.hostname === "youtube.com" ||
        url.hostname.endsWith(".youtube.com") ||
        url.hostname === "youtube-nocookie.com" ||
        url.hostname.endsWith(".youtube-nocookie.com") ||
        url.hostname === "youtube.googleapis.com" ||
        url.hostname.endsWith(".youtube.googleapis.com")
    ) {
        if (
            url.pathname === "/watch" ||
            (url.pathname === "/" &&
                (url.searchParams.has("v") || url.searchParams.has("vi"))) ||
            url.searchParams.has("v") ||
            url.searchParams.has("vi")
        ) {
            const id = url.searchParams.get("v") ?? url.searchParams.get("vi");
            if (id != null && isValidYoutubeId(id)) {
                return id;
            }
        } else if (
            url.pathname.startsWith("/embed/") ||
            url.pathname.startsWith("/video/") ||
            url.pathname.startsWith("/shorts/") ||
            url.pathname.startsWith("/v/") ||
            url.pathname.startsWith("/vi/") ||
            url.pathname.startsWith("/e/")
        ) {
            const parts = url.pathname.split("/");
            if (parts.length >= 3) {
                let id = parts[2];
                if (id.indexOf("&") > 0) {
                    id = id.substring(0, id.indexOf("&"));
                }
                if (id != null && isValidYoutubeId(id)) {
                    return id;
                }
            }
        } else if (url.pathname === "/oembed" && url.searchParams.has("url")) {
            return getYoutubeId(url.searchParams.get("url") ?? "");
        } else if (url.pathname === "/attribution_link") {
            return getYoutubeId(
                url.protocol + "//" + url.host + url.searchParams.get("u")
            );
        } else if (url.pathname.startsWith("/user")) {
            const regex = /^#([a-z0-9]+\/)+(?<id>[^?]+)/;
            const match = url.hash.match(regex);
            if (
                match != null &&
                match.groups?.id != null &&
                isValidYoutubeId(match.groups.id)
            ) {
                return match.groups.id;
            }
        }
    } else if (url.hostname === "youtu.be") {
        let id = url.pathname.substring(1);
        if (id.indexOf("&") > 0) {
            id = id.substring(0, id.indexOf("&"));
        }

        if (isValidYoutubeId(id)) {
            return id;
        }
    }

    return undefined;
}

export function parseVideoData(
    urlString: string | undefined | null
): undefined | YoutubeType {
    if (urlString == null || urlString == "" || urlString.trim() == "")
        return undefined;
    if (typeof urlString != "string") return undefined;

    const youtubeId = getYoutubeId(urlString);
    if (youtubeId != null) {
        return {
            type: "youtube",
            id: youtubeId,
        };
    }

    return undefined;
}
